import base64url from "base64url"

export function idToBase64(id: string) {
  const buffer = Buffer.from(id, "hex")
  return base64url(buffer)
}
